import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { CouponDto, UpdateCouponDto } from "libs/dto/src/coupon";
import { queryClient } from "@/client/libs/query-client";

const updateCoupon = async (id: string, data: UpdateCouponDto) => {
  const response = await axios.patch<CouponDto>(`/coupons/${id}`, data);
  return response.data;
};

export const useUpdateCoupon = () => {
  const {
    mutateAsync: updateCouponFn,
    isPending: loading,
    error,
  } = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCouponDto }) => updateCoupon(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupons"] });
    },
  });

  return { update: updateCouponFn, loading, error };
};
